module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Code/Code-ee76d078b0580fe70d8c6379a33943b58211af84f9bc92af2d6c642b4f7b29dc.svg";